import React, { useEffect, useRef, useState } from 'react'

import DataTableList from '../../components/DataTable/DataTableList'
import NoResults from '../../components/Noresults';
import CustomDatePicker from '../../components/CustomDatePicker';
import Dropdown from '../../components/Dropdown/Dropdown';
import { useStaticDataStore } from '../../stores/staticData';
import { ACCELERATOR_PLAN, PAYMENT_PLAN, USER_MEMBER } from '../../constants/common';
import { formattedDate } from '../../utils/formattedDate';

import search from '../../assets/images/search.svg';
import avatar from '../../assets/images/Avatar.png'
import accelerator from '../../assets/images/accelerator.png'

const SuspendedAccelerators = (props) => {
    const { setShowAddNewAcceleratorsPopup, setSelectAccelerator, isLoading, isLoadingData, acceleratorsList, totalPage, setEditAccelerators, setIsLoadingData, currentPage, setCurrentPage, setSearchQuery, searchQuery, setFilterAccelerator, filterAccelerator, setShowAcceleratorsSuspendPopup, setShowAcceratorsMultipleSuspendPopup, selectedRows, setSelectedRows, isAllSelected, setIsAllSelected, toggleSelect, setErrorMessage, setReason, LazyImage, setAddAcceleratorErrorMessage } = props

    const { data: staticData } = useStaticDataStore();
    const userIndustryRef = useRef();
    const userStartupStagesRef = useRef();
    const userPlanRef = useRef();
    const userRegistedDateRef = useRef();
    const selectMemberRef = useRef()
    const userSuspendedDateRef = useRef();

    let industryTags = [];
    if (staticData?.industryTags?.length) {
        industryTags = staticData?.industryTags;
    }

    let startupStages = [];
    if (staticData?.startupStages?.length) {
        startupStages = staticData?.startupStages;
    }

    const userPlan = ACCELERATOR_PLAN;
    const userMember = USER_MEMBER;

    const [userIndustrySelect, setUserIndustrySelect] = useState(false)
    const [userStartupStagesSelect, setUserStartupStagesSelect] = useState(false)
    const [selectMember, setSelectMember] = useState(false)
    const [anglePlan, setUserAnglesPlanSelect] = useState(false)
    const [userRegistedDateSelect, setUserRegistedDateSelect] = useState(false)
    const [userSuspendedDateSelect, setSuspendedDateSelect] = useState(false)
    const [columnWidths, setColumnWidths] = useState([]);

    useEffect(() => {
        if (acceleratorsList?.length > 0) {
            calculateColumnWidths().then(() => {
                setTimeout(() => {
                    setIsLoadingData(false);
                }, 1000);
            });
        }
    }, [acceleratorsList]);

    const handleMasterCheckboxChange = () => {
        if (isAllSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(acceleratorsList?.map((row) => row?.userId));
        }
        setIsAllSelected(!isAllSelected);
    };

    const handleDelete = async () => {
        if (selectedRows?.length === 1) {
            const selected = acceleratorsList?.find((row) => row?.userId === selectedRows[0]);
            if (selected) {
                setSelectAccelerator(selected);
            }
            setShowAcceleratorsSuspendPopup(true);
        }

        if (selectedRows?.length > 1) {
            setShowAcceratorsMultipleSuspendPopup(true);
        }
        setErrorMessage('')
    };

    const handleEditClick = async (row) => {
        try {
            setEditAccelerators(true);
            setSelectAccelerator(row);
        } catch (error) {
            console.error('Failed to fetch user detail on edit:', error);
        }
    };

    const calculateColumnWidths = () => {
        return new Promise((resolve) => {
            const tempWidths = acceleratorsList?.reduce((acc, row) => {
                Object?.keys(row)?.forEach((key) => {
                    const dataValue = row[key]?.toString();
                    const title = row[key];

                    let maxContentLength = 0;

                    if (key === 'industryTags' || key === 'startupStages') {
                        const categories = row[key];

                        if (categories?.length > 1) {
                            let tempCatLength = 0;

                            for (let i = 0; i < 1; i++) {
                                tempCatLength = tempCatLength + categories[i]?.length;
                            }

                            maxContentLength = Math?.max(tempCatLength, title?.length);

                        } else {
                            if (categories?.length == 0) {
                                maxContentLength = Math?.max(dataValue?.length + 5);
                            } else {
                                maxContentLength = Math?.max(dataValue?.length + 3, title?.length);
                            }
                        }

                    } else {
                        maxContentLength = Math?.max(dataValue?.length, title?.length);
                    }

                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});
            if (tempWidths !== undefined) {
                const widthMap = Object?.keys(tempWidths).reduce((acc, key) => {

                    if (key === 'industryTags' || key === 'startupStages') {
                        acceleratorsList?.forEach((row) => {
                            const categoryWidth = tempWidths[key] * 10 + 40;
                            acc[key] = `${categoryWidth}px`;
                        });
                    } else {
                        acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    }
                    return acc;
                }, {});

                setColumnWidths(widthMap);
            }
            resolve();
        });

    };
    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '24px',
                color: '#666666'
            },
        },
    };

    const columns = [
        {
            name: 'Investor name',
            selector: (row) => row?.name,
            cell: (row) => {
                return <div className="accelerators-content acceleratorsTable" onClick={row?.status === 3 ? () => { handleEditClick(row); setReason(''); } : undefined}>
                    <LazyImage
                        src={row?.profileImg || avatar}
                        alt="Suspended accelerator"
                    />
                    <div className="accelerators-brief">
                        <span className="accelerators-name">
                            {row?.name || 'NO NAME'}
                        </span>
                    </div>
                </div>
            },
            sortable: true,
            minWidth: columnWidths['name'] && `${parseInt(columnWidths['name']) + 45}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 500, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Email address',
            selector: (row) => row?.email,
            cell: (row) => {
                return <p className="user-mail">{row?.email}</p>
            },
            sortable: true,
            width: columnWidths['email'] && (parseInt(columnWidths['email']) > 300) ? '300px' : `${parseInt(columnWidths['email']) + 10}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Accelerator name',
            selector: (row) => row?.companyName,
            cell: (row) => {
                return <span className="accelerators-name">
                    {row?.companyName || 'NO NAME'}
                </span>
            },
            sortable: true,
            width: columnWidths['companyName'] && (parseInt(columnWidths['companyName']) <= 140) ? '170px' : `${parseInt(columnWidths['companyName'])}px`,
            style: {
                paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px'
            },
        },
        {
            name: 'Industry',
            selector: (row) => row?.industryTags || staticData?.industryTags?.map(item => item?.key),
            sortable: false,
            cell: (row) => {
                const industryTags = row?.industryTags?.length
                    ? row?.industryTags
                    : staticData?.industryTags?.map(item => item?.key) || [];

                const industry = industryTags?.slice(0, 1);
                const industryFull = industryTags?.slice(1);

                const getIndustryValue = (key) => {
                    const found = staticData?.industryTags?.find(item => item?.key === key);
                    return found ? found?.value : key;
                };
                return (
                    <div className="industriesCategory">
                        <div>
                            {industry?.map((key, index) => (
                                <span key={index}>{getIndustryValue(key)}</span>
                            ))}
                            {industryTags?.length > 1 && (
                                <div className="industriesList">
                                    <span>+{industryTags?.length - 1}</span>
                                    <div className="industriesTooltip extraToolTip">
                                        {industryFull?.map((key, idx) => (
                                            <p key={idx}>{getIndustryValue(key)}</p>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                );
            },
            paddingLeft: 0,
            width: columnWidths['industryTags'] && `${parseInt(columnWidths['industryTags']) + 40}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", width: columnWidths['industryTags'] && `${parseInt(columnWidths['industryTags']) - 20}px`, lineHeight: '20px' },
        },
        {
            name: 'Startup stage',
            selector: (row) => row?.startupStages || staticData?.startupStages?.map(item => item?.key),
            sortable: false,
            cell: (row) => {
                const startupStages = row?.startupStages?.length
                    ? row?.startupStages
                    : staticData?.startupStages?.map(item => item?.key) || [];

                const startupStage = startupStages?.slice(0, 1);
                const startupStageFull = startupStages?.slice(1);

                const getStartupStageValue = (key) => {
                    const found = staticData?.startupStages?.find(item => item?.key === key);
                    return found ? found?.value : key;
                };
                return (
                    <div className="industriesCategory">
                        <div>
                            {startupStage?.map((item, index) => (
                                <span key={index}>{getStartupStageValue(item)}</span>
                            ))}

                            {startupStages?.length > 1 && (
                                <div className="industriesList">
                                    <span>+{startupStages?.length - 1}</span>
                                    <div className="industriesTooltip">
                                        {startupStageFull?.map((item, idx) => (
                                            <p key={idx}>{getStartupStageValue(item)}</p>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                );
            },
            paddingLeft: 0,
            width: columnWidths['startupStages'] && `${parseInt(columnWidths['startupStages']) + 25}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", width: columnWidths['startupStages'] && `${parseInt(columnWidths['startupStages']) + 40}px`, fontSize: "12px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.24px' },
        },
        {
            name: 'Members',
            selector: (row) => row?.teamCount,
            cell: (row) => {
                return <p className="user-founders">{row?.teamCount}</p>
            },
            sortable: true,
            width: columnWidths['teamCount'] && `${parseInt(columnWidths['teamCount']) + 50}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Plan',
            selector: (row) => row?.plan,
            sortable: true,
            cell: (row) => {
                const matched = userPlan?.find((plan) => plan?.key === row?.plan);
                return (
                    matched?.value ? (
                        <div className='industriesCategory'>
                            <div>
                                <span>{matched?.value}</span>
                            </div>
                        </div>
                    ) : null
                );
            },
            paddingLeft: 0,
            width: columnWidths['plan'] && `${parseInt(columnWidths['plan']) - 170}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "12px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.24px' },
        },
        {
            name: 'Date registered',
            selector: (row) => row?.registeredAt,
            cell: (row) => {
                return <p>{formattedDate(row?.registeredAt)}</p>
            },
            sortable: true,
            width: columnWidths['registeredAt'] && `${parseInt(columnWidths['registeredAt']) - 125}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Date suspended',
            selector: (row) => row?.suspendedAt,
            cell: (row) => {
                return <p>{formattedDate(row?.suspendedAt || row?.registeredAt)}</p>
            },
            sortable: true,
            width: columnWidths['suspendedAt'] && `${parseInt(columnWidths['suspendedAt']) - 145}px`,
            minWidth: '130px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Actions',
            cell: (row) => {
                return (
                    <>
                        {
                            row?.status === 3 &&
                            <div className='table-actions'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" onClick={() => { setShowAcceleratorsSuspendPopup(true); setSelectAccelerator(row); setErrorMessage('') }}>
                                    <path d="M1.5 7.5C1.5 7.5 3.00374 5.45116 4.22538 4.22868C5.44702 3.0062 7.1352 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C5.92268 15.75 3.32633 13.6907 2.51382 10.875M1.5 7.5V3M1.5 7.5H6" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        }
                    </>
                )
            },
            justifyContent: 'flex-end',
            allowOverflow: true,
            button: true,
            minWidth: "55px",
            paddingRight: '16px',
            width: '70px',
            style: { textAlign: 'right', minWidth: '70px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px" },
        },
    ]

    return (
        <div className='active-accelerators'>
            <div className='active-accelerators-top'>
                <div className='pagesSearch twoItemWrap'>
                    <div className="pageSearchInput">
                        <input type="text" name="pages_search" className="inputFields" id="pages_search" placeholder={'Search suspended accelerators...'} autoComplete="off" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                        <img src={search} alt="Search" />
                    </div>

                    <Dropdown ref={userIndustryRef} selectedDropdown={userIndustrySelect} setSelectedDropdown={setUserIndustrySelect} items={industryTags}
                        setSelectedValue={(val) => {
                            setFilterAccelerator(prev => ({
                                ...prev,
                                industry: val
                            }));
                        }}
                        selectedValue={filterAccelerator?.industry} name={"Industry"} />

                    <Dropdown ref={userStartupStagesRef} selectedDropdown={userStartupStagesSelect} setSelectedDropdown={setUserStartupStagesSelect} items={startupStages}
                        setSelectedValue={(val) => {
                            setFilterAccelerator(prev => ({
                                ...prev,
                                startupStage: val
                            }));
                        }}
                        selectedValue={filterAccelerator?.startupStage} name={"Startup stage"} />

                    <Dropdown ref={selectMemberRef} selectedDropdown={selectMember} setSelectedDropdown={setSelectMember} items={userMember}
                        setSelectedValue={(val) => {
                            setFilterAccelerator(prev => ({
                                ...prev,
                                teamCount: val
                            }));
                        }}
                        selectedValue={filterAccelerator?.teamCount} name={"Members"} />

                    <Dropdown ref={userPlanRef} selectedDropdown={anglePlan} setSelectedDropdown={setUserAnglesPlanSelect} items={userPlan}
                        setSelectedValue={(val) => {
                            setFilterAccelerator(prev => ({
                                ...prev,
                                plan: val
                            }));
                        }}
                        selectedValue={filterAccelerator?.plan} name={"Plan"} />

                    <CustomDatePicker
                        onApply={(dateRange) => {
                            setFilterAccelerator(prev => ({
                                ...prev,
                                registedDate: dateRange
                            }));
                            setUserRegistedDateSelect(false);
                        }}
                        selectedDate={filterAccelerator?.registedDate}
                        onCancel={() => setUserRegistedDateSelect(false)}
                        isSelectDate={userRegistedDateSelect}
                        ref={userRegistedDateRef}
                        setSelectDate={setUserRegistedDateSelect}
                        label={"Date registered"}
                    />

                    <CustomDatePicker
                        onApply={(dateRange) => {
                            setFilterAccelerator(prev => ({
                                ...prev,
                                suspendedDate: dateRange
                            }));
                            setSuspendedDateSelect(false);
                        }}
                        selectedDate={filterAccelerator?.suspendedDate}
                        onCancel={() => setSuspendedDateSelect(false)}
                        isSelectDate={userSuspendedDateSelect}
                        ref={userSuspendedDateRef}
                        setSelectDate={setSuspendedDateSelect}
                        label={"Date suspended"}
                    />

                </div>
                <div className='new-accelerators'>
                    {selectedRows?.length > 0 &&
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" onClick={() => { handleDelete(); setReason(''); }}>
                            <path d="M1.5 7.5C1.5 7.5 3.00374 5.45116 4.22538 4.22868C5.44702 3.0062 7.1352 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C5.92268 15.75 3.32633 13.6907 2.51382 10.875M1.5 7.5V3M1.5 7.5H6" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    }
                    <button className='new-accelerators-button' onClick={() => { setShowAddNewAcceleratorsPopup(true); setAddAcceleratorErrorMessage({ name: '', email: '' }) }}>New Accelerator</button>
                </div>
            </div>
            <div className='table-pagination-wrapper accelerators-list'>
                <div className={`pagesTable dataTable-list ${(isLoadingData) ? 'loading-list' : ''}`}>
                    <DataTableList
                        data={acceleratorsList}
                        columns={columns}
                        customStyles={customStyles}
                        onChangePage={setCurrentPage}
                        paginationTotalRows={totalPage}
                        currentPage={currentPage}
                        selectableRowsComponent="input"
                        selectableRows={true}
                        selectAllRows={isAllSelected}
                        onSelectAllChange={handleMasterCheckboxChange}
                        clearSelectedRows={toggleSelect}
                        onSelectedRowsChange={({ selectedRows }) => {
                            const selectedIds = selectedRows?.map((row) => row?.userId);
                            setSelectedRows(selectedIds);
                            setIsAllSelected(selectedIds?.length === acceleratorsList?.length);
                        }}
                        selectableRowDisabled={(row) => row?.status !== 3}
                        progressPending={isLoading}
                        progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                        noDataComponent={<NoResults title='No suspended accelerator' description="Looks like no accelerators have been suspended - that's a good sign! Everyone’s playing nice for now, but if anything changes, you’ll see it here." image={accelerator} />}
                    />
                </div>
            </div>
        </div>
    )
}

export default SuspendedAccelerators
